import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import developerConfig from '@/_data/developerConfig.json' with { type: 'json' };
import type { RootState } from '@/integrations/redux/store';

const initialState = {
    developerMode: developerConfig.developerMode,
    useLocalLanggraph: true,
    strictBindings: true,
    bypassParallelization: true,
    canDispatch: false,
    // When true, /builders and /admin require session.user.isTeamMember.
    // Intended as a dev toggle; server-side enforcement also gates this by NODE_ENV.
    enforceTeamRoutes: false,
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setDeveloperMode: (state, action: PayloadAction<boolean>) => {
            state.developerMode = action.payload;
        },
        setUseLocalLanggraph: (state, action: PayloadAction<boolean>) => {
            state.useLocalLanggraph = action.payload;
        },
        setBypassParallelization: (state, action: PayloadAction<boolean>) => {
            state.bypassParallelization = action.payload;
        },
        toggleBypassParallelization: (state) => {
            state.bypassParallelization = !state.bypassParallelization;
        },
        setEnforceTeamRoutes: (state, action: PayloadAction<boolean>) => {
            state.enforceTeamRoutes = action.payload;
        },
        toggleEnforceTeamRoutes: (state) => {
            state.enforceTeamRoutes = !state.enforceTeamRoutes;
        },
    },
});

export const {
    setDeveloperMode,
    setUseLocalLanggraph,
    setBypassParallelization,
    toggleBypassParallelization,
    setEnforceTeamRoutes,
    toggleEnforceTeamRoutes,
} = configSlice.actions;
export const selectDeveloperMode = (state: RootState) => state.config.developerMode;
export default configSlice.reducer;